// src/platform/dashboards/format.js
//
// Non-component exports for the dashboard primitives.
//
// Split out of primitives.jsx because react-refresh requires a module to export
// components OR values, not both — a mixed module silently loses hot reload for
// every component in it. Formatting helpers and the tone palette are the values;
// primitives.jsx keeps the components.

// ── tone → palette ───────────────────────────────────────────────────────────
//
// The states every dashboard so far needs, plus a neutral. Named for what they
// MEAN: `attention` is "a human has to look at this", which is why flags use it
// and rejections — a finished, intentional verdict — do not.
//
// Deliberately not the accent-* tokens. Those are brand colours used for
// navigation and emphasis across the admin shell; reusing them for chart series
// would make a data mark look like a control.
export const TONE = {
  good:      { fill: "bg-emerald-500", text: "text-emerald-400", hex: "#10b981" },
  attention: { fill: "bg-amber-400",   text: "text-amber-300",   hex: "#fbbf24" },
  bad:       { fill: "bg-red-500",     text: "text-red-400",     hex: "#ef4444" },
  idle:      { fill: "bg-slate-600",   text: "text-slate-400",   hex: "#475569" },
  neutral:   { fill: "bg-accent-info", text: "text-accent-info", hex: "#3AAEE8" },
};

export const toneOf = (t) => TONE[t] ?? TONE.neutral;

/** Thousands-separated, with an em dash for absent rather than a misleading 0. */
export const fmt = (n) => (n == null ? "—" : Number(n).toLocaleString("en-US"));

/** Percentage of b that a represents. Zero denominator yields 0, never NaN. */
export const pct = (a, b) => (b ? (a / b) * 100 : 0);
